export default "/images/5a70dd9c4f4cd21a14c8fc6ddfdb4ed3.avif";